module.exports = __webpack_public_path__ + "img/pic16.ee080133.png";